import { RouteType } from "../@types/RouteType";
import {
    LeadsRoutes,
    DashboardRoutes,
    FinancialRoutes,
    GeneralRoutes,
    OrderRoutesSupport,
    RegistrationRoutes,
    ResourcesRoutes,
    TechSupportRoutes,
    WarrantyClaimRoutes
} from "./MainRoutes";


const DealerSupportRoutes: RouteType[] = [
    ...DashboardRoutes,
    ...OrderRoutesSupport,
    ...RegistrationRoutes,
    ...WarrantyClaimRoutes,
    ...TechSupportRoutes,
    ...FinancialRoutes,
    ...LeadsRoutes,
    ...ResourcesRoutes,
    ...GeneralRoutes
]

export default DealerSupportRoutes;